import React from 'react';
import { KpiCardShell } from '~analytics-components/kpi-card-shell';
import type { AgentCall } from '../utils/agent-thread-state';
import style from '../style.module.scss';

const REPORT_CALL_KPI = 'report';

/** The slot of a call whose KPI or report could not be loaded; what went wrong stays out of sight. */
export const FailedCard: React.FC<{
    call: Pick<AgentCall, 'kpi' | 'summary'>;
}> = ({ call }) => (
    <KpiCardShell title={call.summary} size="sm">
        <div className={style.card_state}>
            <span className={style.card_state_title}>
                {call.kpi === REPORT_CALL_KPI
                    ? 'This report could not be composed'
                    : "Couldn't load this KPI"}
            </span>
        </div>
    </KpiCardShell>
);
